import { Component } from "../../core/Component";

// TODO: we should move properties off sprites/obstructions to here
export class PathingComponent extends Component<[]> {}
